<template>
  <div class="row" style="margin-bottom: 10px; margin-top: 10px">
    <div class="col-md-12 text-center">
      <p
        class="h6 text-secondary"
        v-if="
          retornaSite() == 'Bll' && $siteAdmin == false && propSite !== 'Extra'
        "
        style="margin-bottom: 30px"
      >
        Dark Mode? Selecione em
        <a
          data-toggle="modal"
          data-target="#dialogEditMeusDados"
          role="button"
          type="button"
          style="
            background: none !important;
            border: none;
            color: #069;
            text-decoration: underline;
            cursor: pointer;
          "
          >meus dados</a
        >
      </p>

      <div
        class="h6"
        v-if="
          retornaSite() == 'Bll' && $siteAdmin == false && propSite === 'Extra'
        "
        style="margin-bottom: 30px"
      >
        <div class="d-flex justify-content-center">
          <h3 class="font-weight-bold" v-if="false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-plus-circle"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              />
              <path
                d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
              />
            </svg>
          </h3>

          <h3
            class="ml-2 mr-2 font-weight-bold text-primary"
            style="margin-top: 2px"
          >
            Extra
          </h3>
        </div>
        <p>
          Futebol americano, tênis, hockey, lutas, jogos de futebol com delay
        </p>
      </div>

      <div
        class="row"
        style="margin-bottom: 20px"
        v-if="
          retornaTipoUsuario() == 'Assinante' && planoDias > -1 && planoDias < 5
        "
      >
        <div class="col-md-12 text-center text-danger">
          <a class="btn btn-sm btn-success mb-2" href="/pay" v-if="false">
            Renovar +30 dias via PIX
          </a>
          <h5 v-if="planoDias == 0">
            <small
              >Hoje é o último dia do seu plano</small
            >
          </h5>
          <h5 v-if="planoDias > 0">
            <small>Seu plano vence em {{ planoDias + 1 }} dias</small>
          </h5>
        </div>
      </div>

      <div
        class="row"
        style="margin-bottom: 20px; margin-top: 40px"
        v-if="retornaTipoUsuario() == 'Assinante' && !planoAtivo"
      >
        <div class="col-md-12 text-center text-danger">
          <a class="btn btn-sm btn-success mb-2" href="/pay" v-if="false">
            Renovar +30 dias via PIX
          </a>
          <h3>Entre em contato para renovar seu plano</h3>
        </div>
      </div>

      <div class="row" style="zoom: 1; margin-bottom: 20px; display: none">
        <div class="col-md-12 text-center">
          <span>
            <button
              id="atualizarItens"
              type="button"
              class="btn btn-outline-primary btn-sm"
              style="zoom: 1; margin-top: 10px"
              @click="carregarItens()"
            >
              Atualizar
            </button>
          </span>
        </div>
      </div>

      <div class="row" style="margin-bottom: 50px">
        <div class="col-md-12 text-center">
          <div
            class="homeLegadoGrade"
            :class="{ homeLegadoGradeRecolhida: competicoesRecolhidas }"
          >
            <div class="homeLegadoPrincipal">
              <HomeEventosFerramentas
                :busca="buscaEventos"
                :ordenacao="ordenacaoEventos"
                @update:busca="buscaEventos = $event"
                @update:ordenacao="alterarOrdenacaoEventos"
                @atualizar="carregarItens"
              />
              <ListEventosHome2
                ref="listEventosHome2"
                :aovivo="true"
                :busca="buscaEventos"
                :competicoesSelecionadas="competicoesSelecionadas"
                :ordenacao="ordenacaoEventos"
                :propSite="propSite"
                :propFavorito="propFavorito"
                @eventos-carregados="sincronizarCompeticoes"
              />
            </div>
            <HomeCompeticoesFiltro
              :competicoes="competicoesDisponiveis"
              :recolhido="competicoesRecolhidas"
              :selecionadas="competicoesSelecionadas"
              @alternar="alternarCompeticao"
              @alternar-todas="alternarTodasCompeticoes"
              @recolher="alternarColunaCompeticoes"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import ListEventosHome2 from "../lists/ListEventosHome2";
import HomeEventosFerramentas from "../components/HomeEventosFerramentas";
import HomeCompeticoesFiltro from "../components/HomeCompeticoesFiltro";

function carregarOrdenacaoInicial() {
  try {
    return localStorage.getItem("clienteOrdenacao") == "horario"
      ? "horario"
      : "competicao";
  } catch (erro) {
    return "competicao";
  }
}

function carregarCompeticoesRecolhidas() {
  try {
    return localStorage.getItem("clienteCompeticoesRecolhidas") == "true";
  } catch (erro) {
    return false;
  }
}

export default {
  name: "Home2",
  components: {
    HomeCompeticoesFiltro,
    HomeEventosFerramentas,
    ListEventosHome2,
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    retornaTipoUsuario() {
      return this.$sessao ? this.$sessao.usuario.tipoUsuario : "";
    },
    meusDados() {
      this.$refs.editUsuario.carregarItem("");
    },
    sair() {
      localStorage.removeItem("ckd");
      localStorage.removeItem("ckdCch");

      this.$router.go({ name: "login" });
    },
    carregarItens() {
      this.$refs.listEventosHome2.carregarItens();
    },
    alterarOrdenacaoEventos(ordenacao) {
      this.ordenacaoEventos = ordenacao;
      try {
        localStorage.setItem("clienteOrdenacao", ordenacao);
      } catch (erro) {
        return;
      }
    },
    nomeCompeticao(item) {
      return item.competicao || "Sem competição";
    },
    sincronizarCompeticoes(eventos) {
      var nomesAnteriores = this.competicoesDisponiveis.map(
        (competicao) => competicao.nome
      );
      var todasSelecionadas =
        !this.filtroCompeticoesInicializado ||
        (nomesAnteriores.length > 0 &&
          nomesAnteriores.every((nome) =>
            this.competicoesSelecionadas.includes(nome)
          ));

      this.eventosDisponiveis = eventos;

      var nomes = Array.from(
        new Set(eventos.map((item) => this.nomeCompeticao(item)))
      );
      this.competicoesSelecionadas = todasSelecionadas
        ? nomes
        : this.competicoesSelecionadas.filter((nome) => nomes.includes(nome));
      this.filtroCompeticoesInicializado = true;
    },
    alternarCompeticao(nome) {
      this.competicoesSelecionadas = this.competicoesSelecionadas.includes(nome)
        ? this.competicoesSelecionadas.filter((item) => item !== nome)
        : this.competicoesSelecionadas.concat(nome);
    },
    alternarTodasCompeticoes() {
      this.competicoesSelecionadas = this.competicoesSelecionadas.length
        ? []
        : this.competicoesDisponiveis.map((competicao) => competicao.nome);
    },
    alternarColunaCompeticoes() {
      this.competicoesRecolhidas = !this.competicoesRecolhidas;
      try {
        localStorage.setItem(
          "clienteCompeticoesRecolhidas",
          this.competicoesRecolhidas
        );
      } catch (erro) {
        return;
      }
    },
    isMobile() {
      const isMobile = window.matchMedia("only screen and (max-width: 760px)");
      return isMobile.matches ? true : false;
    },
  },
  data: function () {
    return {
      buscaEventos: "",
      competicoesRecolhidas: carregarCompeticoesRecolhidas(),
      competicoesSelecionadas: [],
      eventosDisponiveis: [],
      filtroCompeticoesInicializado: false,
      ordenacaoEventos: carregarOrdenacaoInicial(),
      planoAtivo: true,
      planoDias: 10,
    };
  },
  computed: {
    competicoesDisponiveis() {
      var competicoes = {};

      this.eventosDisponiveis.forEach((item) => {
        var nome = this.nomeCompeticao(item);

        if (!competicoes[nome]) {
          competicoes[nome] = {
            nome: nome,
            quantidade: 0,
            bandeira: item.competicaoPaisUrl || "/assets/worldflag3.png",
          };
        }

        competicoes[nome].quantidade += 1;
      });

      return Object.values(competicoes).sort((a, b) =>
        a.nome.localeCompare(b.nome, "pt-BR")
      );
    },
  },
  props: {
    propSite: { type: String, default: "" },
    propFavorito: { type: Boolean, default: false },
  },
  async mounted() {
    const response = await api.get("/usuario/meus-dados");
    this.planoAtivo = response.data.item.planoAtivo;
    this.planoDias = response.data.item.planoDias;

    setInterval(this.carregarItens, 20000);
  },
};
</script>

<style>
.tituloJogos {
  margin-top: 15px;
}

.botoesTopo {
  margin-top: 60px;
  justify-content: flex-end !important;
}

@media (max-width: 767.98px) {
  .botoesTopo {
    margin-top: 0px;
    justify-content: center !important;
  }
}
</style>
